import client from "../Client/HttpClient";
import { IPiarModel } from "@/interfaces/modules";

const ApiPath = "Piar";

export default {
    /** GET api/Piar */
    GetAll: (): Promise<IPiarModel[]> =>
        client.get(`${ApiPath}`),

    /** GET api/Piar/{id} */
    GetById: (id: number): Promise<IPiarModel> =>
        client.get(`${ApiPath}/${id}`),

    /** GET api/Piar/byStudent/{studentId} */
    GetByStudentId: (studentId: number): Promise<IPiarModel[]> =>
        client.get(`${ApiPath}/byStudent/${studentId}`),

    /** GET api/Piar/byCourseGroup/{courseGroupId} */
    GetByCourseGroupId: (courseGroupId: number): Promise<IPiarModel[]> =>
        client.get(`${ApiPath}/byCourseGroup/${courseGroupId}`),

    /** GET api/Piar/byPeriod/{periodId} */
    GetByPeriodId: (periodId: number): Promise<IPiarModel[]> =>
        client.get(`${ApiPath}/byPeriod/${periodId}`),

    /** POST api/Piar */
    Post: (data: IPiarModel): Promise<IPiarModel> =>
        client.post(`${ApiPath}`, data),
};
